@for (row of rows; track row; let rowIndex = $index) {
  <!-- $any() is needed because row[rowId] is typed as T[keyof T], but the map key is always a string at runtime -->
  @let mainGuestHasAgeIssue = mainGuestAgeIssueIdMap()[$any(row[rowId])];

  <div class="spa-list-guest-container" data-testid="guest_including_companions">
    <div class="spa-list-row" data-testid="main_guest">
      <div
        class="spa-list-row"
        (click)="onClickRow(row)"
        [ngClass]="{
          'spa-list-selected-row': row[rowId] === selectedRow,
          'spa-list-hint': rowContainsHint(row[rowId]),
          'spa-list-age-issue': mainGuestHasAgeIssue,
          'spa-list-interactive': interactive,
        }"
        id="list-row-{{ rowIndex }}"
        data-testid="selected_person"
      >
        <chd-icon-button
          data-testid="remove_selected_person_button"
          iconSrc="assets/icon/close.svg"
          id="list-row-delete-btn-{{ rowIndex }}"
          variant="text"
          [ariaLabel]="'label.button.close' | transloco"
          (clicked)="removeSelectedEmployee(rowIndex)"
        />

        @if (columns?.left?.length) {
          @for (column of columns.left; track column; let j = $index) {
            <div class="spa-list-element-container" [ngClass]="[column.size ?? '']" [attr.data-testid]="column.key">
              @if (getTemplate(column.key); as tmp) {
                <ng-container *ngTemplateOutlet="tmp.template; context: { row }"></ng-container>
              } @else {
                <chd-text-input
                  id="{{ column.key }}-{{ rowIndex }}"
                  readonly
                  [attr.data-testid]="column.key"
                  [label]="(translationKey(column) | transloco) || ''"
                  [ngClass]="[column.size ?? '']"
                  [optionalLabel]="''"
                  [value]="cellValue(row, column)"
                />
              }
            </div>
          }
        }
      </div>

      @if (columns?.right?.length) {
        @for (column of columns.right; track column) {
          <div class="spa-list-element-container" id="{{ column.key }}-{{ rowIndex }}" [ngClass]="[column.size ?? '']">
            @if (getTemplate(column.key); as tmp) {
              <ng-container *ngTemplateOutlet="tmp.template; context: { row }"></ng-container>
              <div class="spa-list-newprice-tag" id="newprice-{{ rowIndex }}"></div>
            } @else {
              <chd-text-input
                id="{{ column.key }}-{{ rowIndex }}"
                readonly
                [label]="(translationKey(column) | transloco) || ''"
                [ngClass]="[column.size ?? '']"
                [value]="cellValue(row, column)"
              />
            }
          </div>
        }
      }
    </div>

    <!-- Age restriction -->
    @if (mainGuestHasAgeIssue) {
      <chd-error-message>{{
        "text.booking.guest-has-age-issue"
          | transloco
            : {
                age: (row["birthdate"] | calculateAge),
                ageRestriction:
                  ("dto.products.age-restriction." +
                    (bookingCompanionService.s_selectedProduct()?.ageRestriction ?? "NONE") | transloco),
              }
      }}</chd-error-message>
    }

    <!-- Overlapping bookings -->
    <div
      class="spa-list-bottom-space-and-hint-text"
      [title]="rowContainsHint(row[rowId]) ? hintText : ''"
      data-testid="overlapping_booking_hint"
    >
      {{ rowContainsHint(row[rowId]) ? hintText : "" }}
    </div>

    @if (columns?.bottom?.length) {
      @for (column of columns.bottom; track column) {
        @if (getTemplate(column.key); as tmp) {
          <ng-container *ngTemplateOutlet="tmp.template; context: { row }"></ng-container>
        }
      }
    }

    @if (numberOfCompanions() > 0 && !isDifferentPayer) {
      <chd-accordion>
        <chd-expansion-panel
          class="spa-list-companions"
          data-testid="companions_section"
          [title]="`Companions (${(bookingCompanionService.s_companionMap() | filledCompanions: rowIndex)}/${numberOfCompanions()})`"
          [togglePosition]="'before'"
        >
          @for (control of form.controls.companions.controls; track control; let columnIndex = $index) {
            @let companionHasAgeIssue = companionAgeIssueIdMap()[rowIndex + "-" + columnIndex];

            <div class="spa-list-companion" data-testid="companion">
              <div class="spa-list-companions-title">Companion {{ columnIndex + 1 }}</div>
              <div
                class="spa-list-row"
                data-testid="selected_companion"
                id="list-row-{{ rowIndex }}"
                [ngClass]="{ 'spa-list-age-issue': companionHasAgeIssue }"
              >
                @if (bookingCompanionService.s_companionMap()[rowIndex + "-" + columnIndex]) {
                  <chd-icon-button
                    data-testid="remove_companion_button"
                    iconSrc="assets/icon/close.svg"
                    variant="text"
                    [ariaLabel]="'label.button.close' | transloco"
                    (clicked)="removeSelectedCompanion(rowIndex, columnIndex)"
                  />
                  <div class="spa-list-element-container medium" data-testid="companion_name">
                    <chd-text-input
                      readonly
                      [label]="'label.last-name-first-name' | transloco"
                      [optionalLabel]="''"
                      [value]="
                        bookingCompanionService.s_companionMap()[rowIndex + '-' + columnIndex].lastName +
                        ', ' +
                        bookingCompanionService.s_companionMap()[rowIndex + '-' + columnIndex].firstName
                      "
                    />
                  </div>
                  <div class="spa-list-element-container small" data-testid="companion_cabin_number">
                    <chd-text-input
                      readonly
                      [label]="'label.cabin-no' | transloco"
                      [optionalLabel]="''"
                      [value]="bookingCompanionService.s_companionMap()[rowIndex + '-' + columnIndex].cabinNumber"
                    />
                  </div>
                  <div class="spa-list-element-container xsmall-ar" data-testid="companion_age_restriction">
                    <chd-text-input
                      readonly
                      [label]="'bookings.labels.age-restriction' | transloco"
                      [optionalLabel]="''"
                      [value]="
                        'dto.products.age-restriction.' +
                          (simpleProduct()?.companions[columnIndex]?.ageRestriction ?? 'NONE') | transloco
                      "
                    />
                  </div>
                  <div class="spa-list-element-container xsmall-pr" data-testid="companion_price">
                    <chd-text>{{ simpleProduct()?.companions[columnIndex]?.price | formatPricePipe }}</chd-text>
                  </div>
                }
                @if (!bookingCompanionService.s_companionMap()[rowIndex + "-" + columnIndex]) {
                  <div
                    class="spa-autocomplete-search-container"
                    [ngClass]="{
                      'spa-guest-selection-margin-top': bookingCompanionService.s_companionMap(),
                    }"
                  >
                    <spa-autocomplete-search
                      checkboxSelectionType="single"
                      class="spa-search"
                      data-testid="guest_search"
                      [columns]="autocompleteColumns"
                      [isSearching]="isSearching()[rowIndex + '-' + columnIndex]"
                      [rows]="guestSearchResultsMap()[rowIndex + '-' + columnIndex]"
                      (fetchData)="loadGuests($event, rowIndex, columnIndex)"
                      (selectRow)="onSelectCompanions($event, rowIndex, columnIndex)"
                    >
                      <spa-autocomplete-template columnKey="imageUri">
                        <ng-template let-guest="row">
                          <img
                            [src]="guest.data.imageUri | imageUrl"
                            alt="{{ guest.data.lastName }}, {{ guest.data.firstName }}"
                            class="spa-guest-selection-autocomplete-search-img"
                          />
                        </ng-template>
                      </spa-autocomplete-template>
                    </spa-autocomplete-search>
                  </div>
                }
              </div>
            </div>

            <!-- Age restriction -->
            @if (companionHasAgeIssue) {
              <chd-error-message>{{
                "text.booking.guest-has-age-issue"
                  | transloco
                    : {
                        age:
                          (bookingCompanionService.s_companionMap()[rowIndex + "-" + columnIndex]?.birthdate
                          | calculateAge),
                        ageRestriction:
                          ("dto.products.age-restriction." +
                            (simpleProduct()?.companions[columnIndex]?.ageRestriction ?? "NONE") | transloco),
                      }
              }}</chd-error-message>
            }
          }
        </chd-expansion-panel>
      </chd-accordion>
    }

    <div class="footer-container">
      @if (!isDifferentPayer && numberOfCompanions() > 0) {
        <div class="spa-sub-total-container">
          <chd-text type="its">{{ "label.subtotal" | transloco }}</chd-text>
          <chd-text
            data-testid="guest_subtotal_price_original"
            type="ps-bold"
            [ngClass]="{
              discounted:
                bookingCompanionService.s_subTotalPriceMap()[rowIndex] !==
                bookingCompanionService.s_subTotalNetPriceMap()[rowIndex],
            }"
            >{{ bookingCompanionService.s_subTotalPriceMap()[rowIndex] | formatPricePipe }}</chd-text
          >
          @if (
            bookingCompanionService.s_subTotalPriceMap()[rowIndex] !==
            bookingCompanionService.s_subTotalNetPriceMap()[rowIndex]
          ) {
            <chd-text class="netto-price" data-testid="guest_subtotal_price_discounted" type="ps-bold">
              {{ bookingCompanionService.s_subTotalNetPriceMap()[rowIndex] | formatPricePipe }}</chd-text
            >
          }
        </div>
      }
    </div>
  </div>
}
